import {type FC, lazy, Suspense} from 'react';

import type {WebLottieProps} from './types';

import {useAnimationSource} from './useSource';

const LazyCmp = lazy(() =>
  import(
    /* webpackChunkName: "react-lottie-player" */ '@lottiefiles/react-lottie-player'
  ).then(module => ({default: module.Player})),
);

const EmptyCmp = () => null;

const LazyLottieView: FC<WebLottieProps> = props => {
  const {autoPlay, colorify, source, testID, ...rest} = props;

  const newSource = useAnimationSource(source, colorify);

  const lottieProps = {
    ...rest,
    autoplay: autoPlay,
    src: newSource,
  };

  return (
    <Suspense fallback={<EmptyCmp />}>
      <LazyCmp data-test-id={testID} {...lottieProps} />
    </Suspense>
  );
};

const LottieView: FC<WebLottieProps> = props => {
  return <LazyLottieView {...props} />;
};

export {LottieView};
